module.exports = __webpack_public_path__ + "static/media/Student-Community.9323c6df.jpg";